var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"one-philly-home-page"}},[_c('Welcome'),_c('div',{staticClass:"homepage-container"},[_c('ServiceStatus'),_c('Announcements'),_c('PopularServices'),_c('PhillyStat360'),_c('Tools'),_c('Featured'),_c('Services'),_c('Philly311'),_c('CleanGreen'),_c('Mayor'),_c('CityCouncil'),_c('StayConnected')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }